import React, { useState, useEffect, useRef } from "react";
import { Form, Row, Col } from "react-bootstrap";
import WhiteButton from "../../common_components/common_button/WhiteButton";
import "./Step.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetStepsDetail } from "../../../features/admin/kycverification/kyc/Slice";
import { IDS } from "../../../utils/IDS";
import { getUserId, removeUserId } from "../../../utils/authUser";

const user_id = getUserId();

const Step3 = ({ formData, onBack }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openSection, setOpenSection] = useState(1);
  const sectionTopRef = useRef(null);
  const stepContentRef = useRef(null);
  const totalSections = 3; // total tabs

  const stepDetail = useSelector(
    (state) => state?.kycverification?.kyc?.stepdetail,
  );

  const identity = stepDetail?.kyc_identity_verification;
  const personal = stepDetail?.kyc_personal_details;
  const bank = stepDetail?.kyc_bank_details;

  const kycStatus =
  stepDetail?.kyc_identity_verification?.status?.toLowerCase();

  useEffect(() => {
    dispatch(GetStepsDetail());
  }, [dispatch]);

  const nextTab = () => {
    if (openSection < totalSections) {
      setOpenSection(openSection + 1);
    } else {
      // remove stored user_id
      removeUserId();

      navigate("/kycVerified");
    }
  };

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  useEffect(() => {
    if (window.innerWidth <= 768) {
      const element = sectionTopRef.current;

      if (!element) return;

      const yOffset = -300;

      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  }, [openSection]);

  return (
    <section ref={sectionTopRef} className="step1-section step4-section">
      {/* Title Section */}
      <div className="title-section">
        <h2 className="step1-title">Step 04: Review & Submit</h2>
        <p className="step1-subtitle">
          Please review all details carefully before submitting for
          verification.
        </p>
      </div>

      <div className="container">
        <div className="review-container">
          {/* Tabs */}
          <div className="review-tabs d-flex gap-3 mt-3">
            {[
              { id: 1, label: "Identity Verification" },
              { id: 2, label: "Personal & Address Details" },
              { id: 3, label: "Bank / Payment Verification" },
            ].map((tab) => (
              <div
                key={tab.id}
                className={`review-tab ${
                  openSection === tab.id ? "active" : ""
                }`}
                onClick={() => toggleSection(tab.id)}
              >
                {tab.label}
              </div>
            ))}
          </div>
        </div>

        <div className="section-content ">
          {/* SECTION 1 — Identity */}
          {openSection === 1 && kycStatus !== "rejected" && (
            <div className="content-box">
              <Form>
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Label>Select Country</Form.Label>
                    <Form.Control value={"India"} disabled />
                  </Col>

                  <Col md={6}>
                    <Form.Label>Select Document Type</Form.Label>
                    <Form.Control value={"Aadhar Card"} disabled />
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <Form.Label>Document Front Side Image</Form.Label>
                    <div className="image-box front">
                      {identity?.document_front_side && (
                        <img
                          src={`${IDS?.IMG_URL}${identity.document_front_side}`}
                          alt="front"
                          style={{
                            width: "100%",
                            objectFit: "cover",
                          }}
                        />
                      )}
                    </div>
                  </Col>

                  {/* <Col md={6}>
                    <Form.Label>Document Back Side Image</Form.Label>
                    <div className="image-box back">
                      {identity?.document_back_side && (
                        <img
                          src={`${IDS?.IMG_URL}${identity.document_back_side}`}
                          alt="back"
                          style={{
                            width: "100%",
                            
                            objectFit: "cover",
                          }}
                        />
                      )}
                    </div>
                  </Col> */}
                </Row>
              </Form>
            </div>
          )}

          {/* SECTION 2 — Address */}
          {openSection === 2 && kycStatus !== "rejected" && (
            <div className="content-box">
              <Form>
                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Label>Full name (as per ID)</Form.Label>
                    {/* <Form.Control
                      value={formData.fullName || "sarah jamdar"}
                      disabled
                    /> */}
                    <Form.Control value={personal?.full_name || ""} disabled />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Label>Date of Birth</Form.Label>
                    {/* <Form.Control
                      value={formData.dob || "13/03/2026"}
                      disabled
                    /> */}
                    <Form.Control
                      value={personal?.date_of_birth || ""}
                      disabled
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Label>Street address</Form.Label>
                    {/* <Form.Control
                      value={
                        formData.address ||
                        "Akshya Nagar 1St Block 1St Cross, Rammurthy Nagar, Bangalore -560016"
                      }
                      disabled
                    /> */}
                    <Form.Control
                      value={personal?.street_address || ""}
                      disabled
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Label>City</Form.Label>
                    {/* <Form.Control value={formData.city || "Pune"} disabled /> */}
                    <Form.Control value={personal?.city_id || ""} disabled />
                  </Col>

                  <Col md={6}>
                    <Form.Label>Zipcode</Form.Label>
                    {/* <Form.Control
                      value={formData.zipCode || "402103"}
                      disabled
                    /> */}
                    <Form.Control value={personal?.zipcode || ""} disabled />
                  </Col>
                </Row>
              </Form>
            </div>
          )}

          {/* SECTION 3 — Bank */}
          {openSection === 3 && kycStatus !== "rejected" && (
            <div className="content-box">
              <Form>
                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Label>Account Holder Name</Form.Label>
                    <Form.Control
                      value={bank?.account_holder_name || ""}
                      disabled
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Label>Bank Name</Form.Label>
                    <Form.Control value={bank?.bank_name || ""} disabled />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Label>Account Number</Form.Label>
                    <Form.Control value={bank?.account_no || ""} disabled />
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Label>IFSC Code</Form.Label>
                    <Form.Control value={bank?.ifsc_code || ""} disabled />
                  </Col>

                  <Col md={6}>
                    <Form.Label>UPI ID</Form.Label>
                    <Form.Control value={bank?.upi_id || ""} disabled />
                  </Col>
                </Row>
              </Form>
            </div>
          )}
        </div>

        {/* Buttons */}
        <div className="center-btn d-flex justify-content-center mb-5 gap-3">
          <WhiteButton
            className="white-btn"
            title="Back"
            bg="#fff"
            color="#000"
            border="1px solid #000"
            onClick={onBack}
          />

          <WhiteButton
            // title="Save & Next"
            title={
              openSection === totalSections ? "Save & Process" : "Save & Next"
            }
            bg="#000"
            color="#f35f37"
            hoverBg="#000"
            hoverColor="#f35f37"
            onClick={nextTab}
          />
        </div>
      </div>
    </section>
  );
};

export default Step3;
